export default "__VITE_ASSET__0e2bc332__"